import API from "../../../core/api";
import { getGuestAuthSettings } from "../../../core/utils";
import { themeTypographyResetStyles } from "../../../website/components/themeTypographyResetStyles";
import { css } from "@emotion/react";
import {
  Button,
  Modal,
  ModalBody,
  styleUtils,
  Textarea,
  TextInput,
  theme,
} from "@minted/minted-components";
import React, { useCallback, useState } from "react";

const styles = {
  header: css`
    ${themeTypographyResetStyles};
    ${theme.typeStyles.titleExtraLargeStyles};
    margin-top: ${theme.spacing.x4};
    text-align: center;
  `,
  subheader: css`
    ${theme.typeStyles.bodySmallStyles};
    ${theme.typeStyles.bodyBoldStyles};
  `,
  bodyWrapper: css`
    max-width: ${styleUtils.rem(290)};
    margin: 0 auto;
    display: grid;
    gap: ${theme.spacing.x2};
  `,
  buttonsWrapper: css`
    margin-top: ${theme.spacing.x4};
    display: grid;
    gap: ${theme.spacing.x4};
  `,
};

type PropTypes = {
  open: boolean;
  onSkipClick: () => void;
};

const PostGivingMessageModal = ({ open, onSkipClick }: PropTypes) => {
  const [senderName, setSenderName] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      setIsSubmitting(true);

      API.post("registries/post_giving_message/", getGuestAuthSettings(), {
        senderName,
        message,
      })
        .then(() => {
          setSenderName("");
          setMessage("");
          onSkipClick();
        })
        .catch((error) => {
          console.error("Failed to send post-giving message:", error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
    [senderName, message, onSkipClick],
  );

  return (
    <Modal
      closeOnEsc={true}
      closeOnOverlayClick={true}
      displayCloseButton={true}
      onCloseClick={onSkipClick}
      open={open}
    >
      <span css={styles.header}>Post Giving Message</span>
      <ModalBody>
        <form css={themeTypographyResetStyles} onSubmit={handleSubmit}>
          <div css={styles.bodyWrapper}>
            <span css={styles.subheader}>
              Add a note for the couple (optional)
            </span>

            <TextInput
              onChange={(event) => setSenderName(event.target.value)}
              placeholder="Your Name"
              value={senderName}
            />
            <Textarea
              name="postGivingMessage"
              minRows={3}
              onChange={(event) => setMessage(event.target.value)}
              value={message}
            />
            <div css={styles.buttonsWrapper}>
              <Button
                disabled={!message || !senderName || isSubmitting}
                expand
                text="SEND MESSAGE"
                type="primary"
                submit
              />
              <Button
                disabled={isSubmitting}
                expand
                onClick={onSkipClick}
                text="SKIP"
                type="secondary"
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default PostGivingMessageModal;
